import Date                            from "../fundamentals/date/Date";
import Time                            from "../fundamentals/date/Time";
import ReservationBusinessDayTypeClass from "./ReservationBusinessDayTypeClass";

export default class ReservationSpecialBusinessTime {
  constructor(
    private readonly _dayType: ReservationBusinessDayTypeClass = new ReservationBusinessDayTypeClass(),
    private readonly _date: Date = new Date(),
    private readonly _from: Time = Time.ofText("00:00"),
    private readonly _to: Time = Time.ofText("00:00")
  ) {
  }

  get dayType() {
    return this._dayType;
  }

  get date() {
    return this._date;
  }

  get from() {
    return this._from;
  }

  get to() {
    return this._to;
  }
}